import React, { useState, useEffect } from 'react'

function FlightDestinations() {
    const [destinations, setDestinations] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const fetchDestinations = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/flight-destinations/`)
                if (!response.ok) {
                    throw new Error('Failed to fetch destinations')
                }
                const data = await response.json()
                // Only show popular destinations (you can add a filter in backend if needed)
                setDestinations(data.results?.filter(dest => dest.is_featured) || data.results?.slice(0, 6) || [])
                setLoading(false)
            } catch (err) {
                setError(err.message)
                setLoading(false)
            }
        }

        fetchDestinations()
    }, [])

    if (loading) {
        return (
            <section className="flight-destinations-section py-5 bg-light">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    if (error || destinations.length === 0) {
        return (
            <section className="flight-destinations-section py-5 bg-light">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2 className="section-title mb-4">Popular Destinations</h2>
                            <p className="text-muted">No destinations available at the moment.</p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <section className="flight-destinations-section py-5 bg-light">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center mb-5">
                        <h2 className="section-title mb-4">Popular Destinations</h2>
                        <p className="section-subtitle">Explore the most popular flight destinations around the world</p>
                    </div>
                </div>
                <div className="row">
                    {destinations.map((destination) => (
                        <div key={destination.id} className="col-lg-4 col-md-6 mb-4">
                            <div className="destination-card card border-0 shadow-sm h-100 overflow-hidden">
                                <div className="card-img-wrapper position-relative overflow-hidden">
                                    <img 
                                        src={destination.image || '/assets/img/destination/destination_1_1.jpg'} 
                                        className="card-img-top" 
                                        alt={destination.city}
                                        style={{ height: '250px', objectFit: 'cover', transition: 'transform 0.3s ease' }}
                                        onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                                        onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                                    />
                                    <div className="card-img-overlay d-flex flex-column justify-content-end">
                                        <div className="destination-info bg-gradient text-white p-3 rounded">
                                            <h5 className="card-title mb-1">{destination.city}</h5>
                                            <p className="card-text mb-2">
                                                <i className="fas fa-map-marker-alt me-1"></i>
                                                {destination.country}
                                            </p>
                                            {destination.airport_name && (
                                                <small className="text-light">
                                                    <i className="fas fa-plane me-1"></i>
                                                    {destination.airport_name} ({destination.code})
                                                </small>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {destination.description && (
                                        <p className="card-text text-muted mb-3">
                                            {destination.description.substring(0, 100)}
                                            {destination.description.length > 100 ? '...' : ''}
                                        </p>
                                    )}
                                    <div className="d-flex justify-content-between align-items-center">
                                        <button className="btn btn-primary">
                                            <i className="fas fa-search me-2"></i>
                                            Find Flights
                                        </button>
                                        {destination.average_price && (
                                            <span className="text-success fw-bold">
                                                From ${destination.average_price}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="row mt-4">
                    <div className="col-12 text-center">
                        <button className="btn btn-outline-primary btn-lg">
                            <i className="fas fa-globe me-2"></i>
                            View All Destinations
                        </button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FlightDestinations
